import createIcon from '../../createIcon';

/**
 * @component @name PrivacyTip
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMUwzIDVWMTFDMyAxNi41NSA2Ljg0IDIxLjc0IDEyIDIzQzE3LjE2IDIxLjc0IDIxIDE2LjU1IDIxIDExVjVMMTIgMVpNMTEgN0gxM1Y5SDExVjdaTTExIDExSDEzVjE3SDExVjExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PrivacyTip = createIcon('PrivacyTip', [
  [
    'path',
    {
      d: 'M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z',
      key: 'j73gfp',
    },
  ],
]);

export default PrivacyTip;
